// created by wangshuyi on 2022/9/1

'use strict';
import router from '@/router';
import { ajax } from "dolphin-framework-vue";
import index from '../views/index';
import home from '../views/subPage/home';
import aboutUs from '../views/subPage/aboutUs';
import news from '../views/subPage/news';
import fileStorage from '../views/subPage/fileStorage';

import previewPage from '@/views/subPage/previewPage';
import notFound from '@/views/notFound.vue';

const state = {
  cookieName: process.env.VUE_APP_COOKIE_NAME,
  loading: false,
  menuList: [],
  hasMenuLoaded: false,

  menuActive: {},
  menuTab: [],

  prompt: {
    title: '请输入',
    desc: null,
    icon: null,
    visible: false,
    type: 'input',
    onOk: null,
    onCancel: null,
    value: null,
  }
};

const mutations = {
  init(state) {
    const sessionStorageStr = sessionStorage.getItem(state.cookieName);
    if (sessionStorageStr) {
      const sessionInfo = JSON.parse(sessionStorageStr);
      for (const module in sessionInfo) {
        if (/lang/.test(module)) {
          continue;
        }
        for (const field in sessionInfo[module]) {
          if (/loading|prompt/.test(field)) {
            continue;
          }

          this.state[module][field] = sessionInfo[module][field];
        }
      }
    }
  },
  session(state) {
    sessionStorage.setItem(state.cookieName, JSON.stringify(this.state));
  },
  setLoading(state, flag) {
    state.loading = flag;
  },

  saveMenuList(state, menuList) {
    state.menuList = menuList;
    state.hasMenuLoaded = true;
    this.commit('app/session');
  },

};

const actions = {
  queryMenu() {
    return ajax({ url: '/portal/queryMenu', }).then(({ rows }) => {
      this.commit('app/saveMenuList', rows);

      const indexChildren = [
        { path: 'home', name: 'home', component: () => import('@/views/subPage/home') },
        { path: 'aboutUs', name: 'aboutUs', component: () => import('@/views/subPage/aboutUs') },
        { path: 'news', name: 'news', component: () => import('@/views/subPage/news') },
        { path: 'newsDetail', name: 'newsDetail', component: () => import('@/views/subPage/newsDetail') },
        { path: 'fileStorage', name: 'fileStorage', component: () => import('@/views/subPage/fileStorage') },
      ];
      rows.forEach(menu => {
        if (menu.type === 'page') {
          indexChildren.push({
            path: menu._id,
            name: menu.name,
            component: () => import(`@/views/subPage/previewPage`),
          });
        } else {
          menu.children.forEach(child => {
            // if(child.vueLink) console.log(child.vueLink)
            if (child.type === 'page') {
              indexChildren.push({
                path: child._id,
                name: child.name,
                component: () => import(`@/views/subPage/previewPage`),
              });
            }
          });
        }
      });
      router.addRoute({
        path: '/',
        name: 'index',
        component: () => import(`@/views/index`),
        children: indexChildren
      });
      // console.log(router.getRoutes())
      return rows;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
